import styled, { css } from 'styled-components';

export const StyledAddonsSummary = styled.div`
  width: 100%;
`;

export const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Headline = styled.h1`
  ${props => props.theme.typography.heading6};
  margin-bottom: ${props => props.theme.spacing(2)};
  overflow-wrap: break-word;
`;

export const SummaryInfo = styled.div`
  display: block;
`;

export const AvatarContainer = styled.div`
  flex: 1 0 ${props => props.theme.spacing(20)};
  margin-right: ${props => props.theme.spacing(4)};
`;

export const Modify = styled.div`
  display: flex;
`;

const buttonStyle = css`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  ${props => props.theme.typography.bodyBold};
  color: ${props => props.theme.colors.hero.blueberry};
  background: none;
  border: none;
  padding: 0;
  justify-content: center;
`;

export const IconLink = styled.a`
  ${buttonStyle}
`;

export const IconLinkText = styled.span`
  margin-left: ${props => props.theme.spacing(1)};
`;

export const StrikePrice = styled.span`
  text-decoration: line-through;
  color: ${props => props.theme.colors.status.errorPrimary};
`;

export const DiscountedPrice = styled.span`
  font-weight: bold;
  margin-left: 0.5rem;
`;

export const QuantityLabel = styled.span`
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.tertiary)};
`;
